module.exports = __webpack_public_path__ + "static/media/pc-pay.c08a2353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-pay.png
// module id = 2702
// module chunks = 2